// extracted by mini-css-extract-plugin
export default {"zoomModal":"Z4-z","image":"_4-z","button":"a5-z","isOverlayShown":"b5-z"};